// extracted by mini-css-extract-plugin
module.exports = {"popup":"group-hotspot_popup__vW2ka","popupImage":"group-hotspot_popupImage__KJw_O","popupTitle":"group-hotspot_popupTitle__9zT3c"};